import { message } from 'antd'
import { redirectTo } from '../../../helpers/view'
import { withMixin } from '../../../helpers/dva'
import { getUser, getTenantConfig } from './service'
import { loginOut, getUserPrivacy } from '../../../services/common'
import { dealWithMenus } from '../../../helpers/text'
// import logoURL from '../../../assets/oppoLogo.png' //oppo 的logo
import logoURL from '../../../assets/dfocusLogo.svg' //dfocus 的logo
import { getCompanyInfo } from '../../../pages/company-setting/service'
import judgingEnv from '../../../helpers/judgingEnv'
import sso from './sso'
import { getAuthToken, setAuthToken, setCanChangepws, removeAuthToken } from '../../../helpers/storage'
import { formatMessage } from 'umi-plugin-react/locale'

export default withMixin({
  state: {
    logoURL,
    pcTitle: ''
    // applicationName: '工位空间分配管理'
  },

  effects: {
    *autoLogin({ payload }, { put, call, select }) {
      const token = getAuthToken()
      const { location } = window
      const { href, origin } = location
      const currentUrl = href.slice(origin.length)
      const type = yield judgingEnv()

      // and even no Authorization in cookie
      if (!token) {
        const { success } = yield sso(type)
        if (success) {
          return
        }
        if (currentUrl === '/') {
          return redirectTo('/login')
        }
        return redirectTo('/login', currentUrl)
      }
      try {
        const info = yield call(getUser)
        const { success, data, errorCode } = info
        if (errorCode === 200 && data.deskNumberException) {
          message.warning(formatMessage({ id: 'LICENSE_COUNT_DEFAULT_TIPS' }))
        }
        if (!success || errorCode !== 200 || !data) {
          removeAuthToken()
          if (currentUrl === '/') {
            return type === 'wechat'
              ? redirectTo({
                  pathname: '/login',
                  state: {
                    is3rd: true
                  }
                })
              : redirectTo('/login')
          }
          return type === 'wechat'
            ? redirectTo({
                pathname: '/login',
                state: {
                  is3rd: true
                }
              })
            : redirectTo('/login', currentUrl)
        }
        const { data: tenantConfig } = yield call(getTenantConfig, {
          code: `api.response.address.code.${data.tenantId}`
        })
        const companyInfo = yield call(getCompanyInfo)
        yield put({
          type: 'updateState',
          payload: {
            pcTitle: companyInfo.data.pcTitle,
            logoURL: companyInfo.data.logo
          }
        })

        setAuthToken(data.token)
        yield put({
          type: 'users/updateState',
          payload: {
            currentUser: dealWithMenus(data),
            locationAlias: tenantConfig
          }
        })

        yield put({
          type: 'queryUserPrivacy',
          payload: {}
        })

        //需要修改密码
        if (data.isChangePassword === 0 || data.isChangePassword === 2) {
          if (data.isChangePassword === 2) {
            message.warning(formatMessage({ id: 'PASSWORD_HAS_BEEN_MODIFY_TIPS' }))
          }
          setCanChangepws(data.isChangePassword)
          return redirectTo('/changePassword')
          // if (currentUrl === '/') {
          //   return redirectTo('/')
          // }
          // return redirectTo('/changePassword', currentUrl)
        }
      } catch (err) {
        return err.message && message.error(err.message)
      }
    },
    *loginOut({ payload }, { call, put }) {
      const { success } = yield call(loginOut, payload)
      removeAuthToken()
      redirectTo('/login')
      yield put({
        type: 'login/updateState',
        payload: {
          hide: true,
          imgSrc: '',
          tokenCode: null
        }
      })
      if (!success) {
        return false
      }
    },
    *queryUserPrivacy({ payload }, { put, call, select }) {
      const { success, data } = yield call(getUserPrivacy)
      if (!success) {
        return
      }
      const hasVal = data && data !== 'true' && data !== true
      yield put({
        type: 'users/updateState',
        payload: {
          userPrivacy: hasVal ? data : null
        }
      })
    }
  },
  reducers: {
    updateLogo(state, { payload }) {
      return {
        ...state,
        logoURL: payload
      }
    }
  }
})
